import { ReactNode } from 'react';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { t } from 'localization/utils/t';

const TP = 'shared.components.ShareButton';

export interface IShareButtonProps extends ShareData {
  className?: string;
  'data-qa'?: string;
  children?: ReactNode;
  hideIfUnavailable?: boolean;
  onShared?: () => void;
  onError?: (error) => void;
}

export const ShareButton = ({
  className,
  children,
  'data-qa': dataQa = 'share_button',
  hideIfUnavailable = true,
  onShared,
  onError,
  ...shareData
}: IShareButtonProps) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const isSharingAvailable = Boolean(navigator?.canShare);
  if (!isSharingAvailable && hideIfUnavailable) return null;

  const canShare = isSharingAvailable && navigator.canShare(shareData);

  const share = async () => {
    if (!canShare) return;

    try {
      await navigator.share(shareData);
      onShared?.();
    } catch (error) {
      // this error can be caused by the user dismissing the share modal
      // which is normal behavior.
      if (!error.toString().includes('AbortError')) {
        bugsnag(error, { context: 'Failed Share Attempt' });
      }
      onError?.(error);
    }
  };

  return (
    <button
      className={className}
      data-qa={dataQa}
      onClick={share}
      disabled={!canShare}
      type="button"
    >
      {children ?? t(`${TP}.share`, 'Share')}
    </button>
  );
};
